import request from '@/utils/request'
import { getShopId } from '@/api/shop/shopApi'

/**
 * 查询店铺小区列表
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function queryShopCommunity(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shop.queryShopCommunity',
      method: 'get',
      params: {
        ...params,
        shopId: getShopId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 查询可入驻小区列表
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function queryShopFreeCommunity(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shop.queryShopFreeCommunity',
      method: 'get',
      params: {
        ...params,
        shopId: getShopId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 保存店铺小区
 * @param {Object} data 保存数据
 * @returns {Promise} Promise对象
 */
export function saveShopCommunity(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shop.saveShopCommunity',
      method: 'post',
      data: {
        ...data,
        shopId: getShopId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 修改店铺小区
 * @param {Object} data 修改数据
 * @returns {Promise} Promise对象
 */
export function updateShopCommunity(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shop.updateShopCommunity',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 删除店铺小区
 * @param {Object} data 删除数据
 * @returns {Promise} Promise对象
 */
export function deleteShopCommunity(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shop.deleteShopCommunity',
      method: 'post',
      data: {
        ...data,
        shopId: getShopId()
      }
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        // API 层只负责返回结果，成功提示由调用组件统一处理，避免在普通函数中访问 this.$message 导致 TypeError
        resolve(res)
      } else {
        reject(res.msg)
      }
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 获取地区列表
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function listAreas(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/area.listAreas',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}